<template>
  <validation-observer ref="providerObserver">
    <v-container fluid>
      <v-switch
        dense
        :disabled="isDisabled"
        v-model="checkoutActivatedProxy"
        :label="$t('findInStore.settings.activateCheckout')"
      />
      <v-alert v-if="isDisabled" dense type="warning" text>
        <div>{{ $t('findInStore.settings.checkoutActivationMessage') }}</div>
      </v-alert>
      <v-card v-if="displayCheckoutFields" outlined class="mt-3">
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6">
              <validation-provider rules="required|url" :name="$t('findInStore.settings.checkoutUrl')" v-slot="{ errors }">
                <v-text-field
                  hide-details="auto"
                  :disabled="!isOctipasAdmin"
                  outlined
                  dense
                  v-model="settings.url"
                  :label="$t('findInStore.settings.checkoutUrl')"
                  :error-messages="errors"
                  required
                  clearable
                ></v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
  </validation-observer>
</template>
<script>
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { mapState } from 'vuex'

  export default {
    name: 'FindInStoreSettingsCheckout',
    components: {
      ValidationProvider,
      ValidationObserver,
    },
    props: {
      settings: {
        type: Object,
        required: true,
      },
      checkoutActivated: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapState(['isAdmin', 'isOctipasAdmin']),
      isDisabled() {
        return !this.isOctipasAdmin && this.isAdmin && !this.settings.url
      },
      checkoutActivatedProxy: {
        get() {
          return this.checkoutActivated
        },
        set(value) {
          this.$emit('update:checkoutActivated', value)
        },
      },
      displayCheckoutFields() {
        return this.checkoutActivated
      },
    },
    methods: {
      async hasErrors() {
        const valid = await this.$refs.providerObserver.validate()
        return !valid
      },
    },
  }
</script>
